import React from 'react';
import { PrismButton } from '@prism-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from "prop-types";

class SaveAndStepButton extends React.Component {


    handleContinue = (event) => {
        if (event?.preventDefault) event.preventDefault();
        if (this.props.componentsToCheck && this.props.componentsToCheck.length > 0) {
            let isValid = true;
            let invalidComponentForm = null;
            for (let componentName of this.props.componentsToCheck) {
                const component = document.getElementsByName(componentName)[0] || document.getElementById(componentName);
                if (component && typeof component.checkValidity === 'function' && !component.checkValidity()) {
                    invalidComponentForm = component.form
                    isValid = false;
                    break;
                }
            }
            if (!isValid && invalidComponentForm) {
                invalidComponentForm.reportValidity();
            } else if (isValid) {
                this.props.onSave()
                    .then(this.props.onSuccessFunction)
                    .catch((error) => {
                        console.error('Save failed:', error);
                    });
            }
        }
        else {
                this.props.onSave()
                    .then(() => {
                        this.props.onSuccessFunction();
                    })
                    .catch((error) => {
                        console.error('Save failed:', error);
                    });
        }
    }
  render() {
    const isIconFirst = this.props.iconPosition === 'left';
    return (

      <PrismButton
        disabled={this.props.disabled}
        tone="primary-brand"
        size="lg"
        onPrismClick={this.handleContinue}>
          {isIconFirst && this.props.icon && <FontAwesomeIcon icon={this.props.icon} />}
          {' '}{this.props.buttonText}{' '}
          {!isIconFirst && !this.props.lastStep && this.props.icon && <FontAwesomeIcon icon={this.props.icon} />}
      </PrismButton>

    );
  }
}
SaveAndStepButton.propTypes = {
  componentsToCheck: PropTypes.array, // Fixed: was fieldsToCheck but code uses componentsToCheck
  onSave: PropTypes.func.isRequired, //function to perform saving attributes to the database
  onSuccessFunction: PropTypes.func.isRequired, //function to perform after saving attributes to the database
  iconPosition: PropTypes.oneOf(['left', 'right']),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  variant: PropTypes.string,
  icon: PropTypes.object, // FontAwesome icons are objects
  buttonText: PropTypes.string,
  lastStep: PropTypes.bool
};
export default SaveAndStepButton;

